/* Квадрат той же высоты, что и остальные контролы полосы: она читается как
   одна строка одного роста. Позиционирование нужно кольцу приглашения. */
.tourBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--ctl-h);
  height: var(--ctl-h);
  padding: 0;
  flex: none;
  color: var(--text-2);
}

.tourBtn:hover {
  color: var(--text);
}

/* В бургер-меню — строка во всю ширину с подписью: там кнопка стоит среди
   таких же блоков, и голый компас не опознать. */
.tourRow.tourRow {
  width: 100%;
  height: auto;
  justify-content: flex-start;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  color: var(--text);
}

/* ── Приглашение: пока тур не открывали ──────────────────────────────────
   Кромка со свечением медленно набирается и почти три секунды гаснет — это
   дыхание, а не мигание. Полную яркость держит доли секунды: в полосе, куда
   человек смотрит постоянно, что-то более настойчивое быстро надоест.

   Ничего за пределы кнопки не выходит намеренно: группа контролов полосы
   живёт под overflow (см. Toolbar.module.css), и расходящееся кольцо она
   срезала бы сверху и снизу.

   Отдельный слой, а не box-shadow самой кнопки: у .btn на ней уже висят
   свечение и кольцо фокуса, и анимация затирала бы их. */
.pulse::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border: 1px solid color-mix(in srgb, var(--focus) 62%, transparent);
  box-shadow: inset 0 0 9px color-mix(in srgb, var(--focus) 12%, transparent);
  opacity: 0;
  pointer-events: none;
  animation: tourPulse 3400ms ease-in-out infinite;
}

/* Сам компас держится чуть контрастнее соседей, пока зовёт. */
.pulse {
  color: var(--text);
}

/* Наведение и фокус приглашение снимают: человек кнопку уже нашёл, и
   продолжать махать ему в лицо незачем. */
.pulse:hover::after,
.pulse:focus-visible::after {
  animation: none;
  opacity: 0;
}

@keyframes tourPulse {
  0%,
  100% {
    opacity: 0;
  }
  /* Пик намеренно неполный: кромка должна проступить, а не загореться. */
  18%,
  30% {
    opacity: 0.62;
  }
}

/* Движение выключено — приглашение остаётся: без него кнопку не найти вовсе.
   Кромка просто стоит на месте, не разгораясь и не гаснув. */
@media (prefers-reduced-motion: reduce) {
  .pulse::after {
    animation: none;
    opacity: 0.55;
  }
}
